<template>
  <ResponseContainer>
    <div v-if="admin">
      <div v-if="success" @click="clearSuccess()" class="w-full p-4 bg-theme-pink/25 rounded-md cursor-pointer"><span class="font-bold">Success: </span>{{ success }}</div>
      <h2>Group management</h2>
      <h3>Add group</h3>
      <input type="text" name="key" v-model="group.name" placeholder="Name" autocomplete="off">
      <button @click="addGroup()">Add →</button>
      <h2>Guest management</h2>
      <h3>Add guest</h3>
      <input type="text" name="name" v-model="guest.name" placeholder="Name" autocomplete="off">
      <div class="grid mb-4">
        <select required name="group" v-model="guest.group">
          <option selected disabled value="">Select group</option>
          <option v-for="g in groups" :key="g" :value="g.id">{{ g.name }}</option>
        </select>
        <svg class="pointer-events-none relative right-1 z-10 col-start-1 row-start-1 h-4 w-4 self-center justify-self-end forced-colors:hidden" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"></path></svg>
      </div>
      <button @click="addGuest()">Add →</button>
      <h3>Guest list</h3>
      <button @click="viewGuests()">View →</button>
      <h2>Import</h2>
      <button @click="importGuests()">Run import →</button>
      <h2>Testing</h2>
      <button @click="seedGuests()">Seed guests →</button>
    </div>
    <div v-else>
      <input type="text" name="secret" v-model="secret" placeholder="Admin secret" autocomplete="off">
      <button @click="checkSecret()" :disabled="wait">I am admin →</button>
    </div>
  </ResponseContainer>
</template>

<script>
import ResponseContainer from '@/pages/ResponseContainer'
import Guest from '@/models/guest'
import Group from '@/models/group'
import Cookie from '@/helpers/cookie'
import Data from '@/scripts/data'

export default {
  name: 'AdminPage',
  components: {
    ResponseContainer,
  },
  data() {
    return {
      admin: false,
      wait: false,
      secret: '',
      group: {
        key: '',
      },
      guest: {
        name: '',
        group: '',
      },
      groups: [],
      success: undefined,
    }
  },
  beforeMount() {
    this.autoSecret()
    this.loadGroups()
  },
  methods: {
    async loadGroups() {
      this.groups = await Group.getAll()
    },
    async addGroup() {
      const result = await Group.create(this.group.name)
      this.success = result.toString()
      this.group = {
        name: '',
      }
    },
    async addGuest() {
      const result = await Guest.create(this.guest.name, this.guest.group)
      this.success = result.toString()
      this.guest = {
        name: '',
        group: '',
      }
    },
    async viewGuests() {
      this.$router.push('/admin/guests')
    },
    async importGuests() {
      await Data.import()
      this.success = 'Imported all guests'
    },
    async seedGuests() {
      // await Group.create('Ambat Family', [
      //   'Julia Ambat',
      //   'James Ambat',
      //   'Jeffrey Ambat',
      //   'Jamie Ambat',
      //   'Maribel Ambat',
      // ], true)
      await Group.create('Single', [
        'Pringle Man',
      ], false)
      this.success = 'Created Ambat Family and Pringle Man as test groups'
    },
    clearSuccess() {
      this.success = undefined
    },
    autoSecret() {
      const secret = Cookie.get('admin')
      if (secret === process.env.VUE_APP_ADMIN_SECRET) {
        this.admin = true
      }
    },
    async checkSecret() {
      if (this.secret === process.env.VUE_APP_ADMIN_SECRET) {
        this.admin = true
        Cookie.set('admin', this.secret)
      } else {
        const delay = ms => new Promise(res => setTimeout(res, ms))
        this.wait = true
        await delay(60 * 1000)
        this.wait = false
      }
    },
  },
}
</script>